import { MapPinIcon } from "@heroicons/react/24/outline";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { LoadingSkeleton6 } from "../../components/Skeletons";

const Index = () => {
  const [data, setData] = useState();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/OnlineOrdering/GetAllBusinessList`);
        if (!response.ok) throw new Error("Failed to fetch data");
        const jsonData = await response.json();
        if (jsonData.data.length <= 0) throw new Error();
        setData(jsonData.data);
      } catch (error) {
        toast.error("error getting businesses");
      }
    };
    if (!data) fetchData();
  }, []);

  data?.map((item, i) => {
    // console.log(item);
    // console.log(JSON.parse(item.businessInfo));
    // console.log(JSON.parse(item.businessInfo).business[0]);
  });

  return (
    <section className="flex justify-center items-center min-h-screen">
      {data ? (
        <div className="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 gap-10 p-10 items-center">
          {data?.map((item, i) => (
            <Card key={i} data={item} />
          ))}
        </div>
      ) : (
        <LoadingSkeleton6 />
      )}
    </section>
  );
};

const Card = ({ data }) => {
  const businessInfo = data?.businessInfo ? JSON.parse(data.businessInfo) : null;
  return (
    <Link
      to={data?.businessName.toLowerCase().startsWith("foodb_") ? data?.businessName.split("_")[1] : data?.businessName}
      className="relative cursor-pointer group hover:scale-105 transition-all shadow-lg rounded-lg p-10 overflow-hidden"
    >
      <img
        className="absolute z-0 top-0 left-0 h-full w-full object-cover"
        src="/images/brands/bunchiz.png"
        alt="background image for card"
      />
      <div className="absolute bg-white/30 blur-xl z-10 w-[200%] h-6 rotate-45 transition-transform duration-500 ease-out translate-x-full group-hover:-translate-x-[110%]" />
      <div className="absolute group-hover:bg-secondary/50 transition-colors top-0 left-0 bg-secondary/70 w-full h-full" />
      <div className="relative z-10 transition-all text-white group-hover:text-secondary  group-hover:bg-white rounded-lg p-4 text-center">
        <h3 className="font-semibold text-2xl">{businessInfo?.company_name}</h3>
        <div className="scale-0 group-hover:scale-100 h-fit transition-all">
          {/* {data?.minimumOrder ? (
            <p className="text-primary-dark">
              Pricing : {data?.minimumOrder < 30 ? (data?.minimumOrder < 10 ? "$" : "$$") : "$$$"}
            </p>
          ) : null} */}
          {businessInfo?.company_address ? (
            <div className="flex items-center justify-center text-start text-sm text-secondary/50 py-[2px]">
              <MapPinIcon className="w-5 h-5 mr-1 mb-auto" />
              {businessInfo?.company_address}
            </div>
          ) : null}
          {/* {data?.address || data?.location || data?.state ? (
            <div className="flex items-center justify-center text-start text-sm text-secondary/50 py-[2px]">
              <MapPinIcon className="w-5 h-5 mr-1 mb-auto" />
              {data?.address}, {data?.location}, {data?.state}
            </div>
          ) : null} */}
        </div>
      </div>
    </Link>
  );
};

export default Index;
